export const chartReview = {
  title: 'Chart Review',
  tabs: {
    pending: 'Pending',
    inProgress: 'In Progress',
    signedOff: 'Signed Off'
  },
  grid: {
    patientName: 'Patient Name',
    numCriticalAlerts: 'Num of Critical Alerts',
    reportMonthAndYear: 'Report Month And Year',
    dateOfBirth: 'Date of Birth',
    signedOffAt: 'Signed Off At',
    healthPlan: 'Health Plan'
  },
  snackbars: {
    fetchReportsFailed: 'Something went wrong, failed to retrieve Review Patients. Please try again later.',
    fetchCountsFailed: 'Something went wrong, failed to retrieve Review Patients counts. Please try again later.'
  }
} as const;
